import {FC} from 'react';
import {Stack, Typography} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import {EmptyTableWrapper} from '../EmptyTableWrapper';
import {EmptyIcon} from '../../icons/EmptyIcon';

export const EmptyTable: FC = () => (
    <EmptyTableWrapper>
        <Typography variant="subtitle1">
            <Stack sx={{py: 2, alignItems: 'center'}}>
                <EmptyIcon/>
                <FormattedMessage id="noData"/>
            </Stack>
        </Typography>
    </EmptyTableWrapper>
);
